"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var defaults = {
  domain: null,
  isResolving: false,
  isSslEnabled: false
};

var CustomHostedDomain =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(CustomHostedDomain, _Record);

  function CustomHostedDomain() {
    (0, _classCallCheck2.default)(this, CustomHostedDomain);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CustomHostedDomain).apply(this, arguments));
  }

  (0, _createClass2.default)(CustomHostedDomain, null, [{
    key: "from",
    value: function from(json) {
      if (json) {
        return new CustomHostedDomain({
          domain: json.domain,
          isResolving: json.isResolving,
          isSslEnabled: json.isSslEnabled
        });
      }

      return new CustomHostedDomain();
    }
  }]);
  return CustomHostedDomain;
}((0, _immutable.Record)(defaults));

exports.default = CustomHostedDomain;
module.exports = exports.default;